import { render } from "./LinkedinDialog.vue?vue&type=template&id=1b97a24e"
import script from "./LinkedinDialog.vue?vue&type=script&lang=js"
export * from "./LinkedinDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__